<template>
  <div>
    <section>
      <!-- <van-nav-bar
          title=""
          :left-text="newData.channelName"
          right-text="读报"
          left-arrow
          :border="false"
          @click-left="onClickLeft"
          @click-right="onClickRight"
      /> -->
      <van-nav-bar
        title=""
        left-arrow
        left-text="7000万人都在看"
        :border="false"
        @click-left="onClickLeft"
        style="background: #f8f8f8"
      >
        <template #right>
          <div class="top-recmm" @click="onClickRight">
            <p
              style="
                margin-right: 20px;
                color: #164a9a;
                font-size: 12px;
                padding: 0px 4px;
                border: 1px solid #164a9a;
                border-radius: 12px;
              "
            >
              精彩业务推荐
            </p>
          </div>
          <van-icon name="weapp-nav" @click="openBottomPannel" />
        </template>
      </van-nav-bar>
    </section>
    <section>
      <div class="contents" v-if="!error">
        <div v-if="loading">
          <van-skeleton title :row="5" />
        </div>

        <div v-if="!loading">
          <div
            v-if="keywordHighlightEnabled"
            class="h2subject"
            v-html="highlightedTitleHtml"
          ></div>
          <div v-else class="h2subject">{{ newData.title }}</div>
          <div
            v-if="keywordHighlightEnabled && highlightedSubTitleHtml"
            class="article-subtitle"
            v-html="highlightedSubTitleHtml"
          ></div>
          <div
            v-else-if="newData.subTitle && newData.subTitle.trim()"
            class="article-subtitle"
          >
            {{ newData.subTitle }}
          </div>

          <div v-if="newData.type === 1 || newData.type == 5">
            <div class="article-meta-right">
              <div
                v-if="previewStatusConfig"
                class="article-status"
                :style="{ color: previewStatusConfig.color }"
              >
                状态：{{ previewStatusConfig.label }}
              </div>
              <div class="views" v-if="showHeat">
                热度：{{ newData.currentHeat }}
              </div>
            </div>

            <div class="thread-star">
              <div class="time">
                <div class="scsjb_info">
                  <div class="author">
                    <van-image
                      round
                      src="/img/logo-500.jpg"
                      class="dlogo"
                    ></van-image>
                  </div>
                  <div class="user_info">
                    <div class="n">
                      <span class="path"
                        >四川手机报/{{ newData.categories.name }}</span
                      ><template v-if="breadcrumbTopic"
                        ><span class="path">/</span
                        ><span
                          class="topic topic-link"
                          @click="goTopic(breadcrumbTopic.id)"
                          >专题:{{ breadcrumbTopic.title }}</span
                        ></template
                      >
                    </div>
                    <div class="t">
                      {{ today }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              ref="messageContent"
              class="message"
              :style="{ fontSize: fontSize + 'px' }"
              v-html="processedContent"
            ></div>
            <div
              class="origin"
              v-if="newData.originalLink !== ''"
              :style="{ fontSize: fontSize + 'px' }"
            >
              来源：{{ newData.originalLink }}
            </div>
          </div>

          <!--          <div v-if="newData.type == 3">
            <div class="thread-star">
              <div class="time">
                {{ newData.publishTime }}
              </div>
            </div>
            <div class="photocentent" style="margin-top: 20px">
              <div class="imgs" v-for="(item, k) in newData.content" :key="k">
                <van-image :src="item.img" fit="cover" @click="view(k)" />
                <div class="desc">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>-->
          <!-- <a
              href="https://work.weixin.qq.com/kfid/kfca7acc7eceb85b855"
              target="_blank"
            >
              <img
                src="/img/qrcode_l.jpg"
                class="album-pic"
                style="width: 19%"
              />
            </a>
            <a href="/img/qrcode_r.jpg" target="_blank">
              <img
                src="/img/qrcode_r.jpg"
                class="album-pic"
                style="width: 63%"
              />
            </a> -->

          <!--          <div class="promotion" v-show="newData.promotion.length > 0">
            <a
              href="https://work.weixin.qq.com/kfid/kfc49be9d74f7a967d1"
              target="_blank"
              >点击加群 回复“<span style="color: #f00">{{
                newData.promotion[0]
              }}</span
              >”<br />
              &nbsp; 加入“<span style="color: #f00">{{
                newData.promotion[1]
              }}</span
              >”</a
            >
          </div>-->
        </div>
        <van-swipe
          class="my-swipe"
          :autoplay="1000000"
          style="height: 195px"
          indicator-color="white"
          v-if="showRelatedArticles"
        >
          <!--          <van-swipe-item v-for="(item, k) in headline" :key="k">
            <div class="thumb" @click="goView(item.id, item.type)">
              <van-image :src="item.titleImgUrl"></van-image>
              <div class="title">{{ item.title }}</div>
            </div>
          </van-swipe-item>-->
          <van-swipe-item v-for="(item, k) in headline" :key="k">
            <div class="thumb" @click="goView(item)">
              <van-image
                :src="item.fullwidthTopUrl"
                style="aspect-ratio: 2/1"
              ></van-image>
              <div class="title">{{ item.title }}</div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="error" v-if="error">
        <van-empty :description="errorT" />
      </div>

      <!-- <div class="line1"></div> -->
      <div>
        <div class="newsList" v-if="showRelatedArticles">
          <div class="lable-title"><span>热点推荐</span></div>

          <div class="error" v-if="error2">
            <van-empty :description="error2T" />
          </div>
          <div v-if="!loading2" style="padding-top: 10px">
            <div
              class="news-item"
              v-for="(v, k) in relatedNewsData"
              :key="k"
              @click="goView(v)"
            >
              <div class="right-content">
                <a class="subject" href="">{{ v.title }}</a>
              </div>
              <div class="thumb">
                <van-image :src="v.thumbnail"></van-image>
              </div>
            </div>
          </div>
          <div v-if="loading2">
            <div class="loading">
              <van-loading type="circular" color="#999" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="copyright">
      <p>
        <a href="https://www.scsjb.cn">四川手机报</a
        ><a href="https://www.mala.cn">麻辣社区</a
        ><a href="http://www.newssc.org/">四川新闻网</a>
      </p>
      <!-- <p>Copyright © 2021 - 四川手机报</p> -->
      <p>
        Copyright © 2021 - 四川手机报<br />蜀ICP备12003267号-1<br />互联网新闻信息服务许可证编号:51120170002
      </p>
    </section>
    <van-action-sheet v-model="bottomPannel" close-on-click-action>
      <van-picker
        show-toolbar
        title="字体大小"
        :columns="columns"
        :default-index="defaultIndex"
        @confirm="onChangeFontSizeConfirm"
        @cancel="onChangeFontSizeCancel"
        onClick
      />
    </van-action-sheet>

    <div
      v-if="keywordTip.show"
      id="keyword-tip"
      class="keyword-tip"
      :style="{ left: keywordTip.left + 'px', top: keywordTip.top + 'px' }"
    >
      <div class="keyword-tip-title">触发关键字</div>
      <div
        v-for="group in keywordTip.groups"
        :key="group.type"
        class="keyword-tip-item"
      >
        <div class="keyword-tip-label">{{ group.label }}：</div>
        <div class="keyword-tip-list">
          <span
            v-for="(kw, index) in group.keywords"
            :key="group.type + '-' + index"
            class="keyword-tip-tag"
            :style="{ backgroundColor: group.bg, color: group.color }"
          >
            {{ kw }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isWechat, wechatShare } from "../commJs/wechat";
// import { getView, getList, getTonglan, getRelatedNews } from "../commJs/api";
import { ImagePreview } from "vant";
import { getTonglan, getView } from "../commJs/api";
import {
  checkContent,
  getArticleVoById,
  getRelatedArticles,
  queryPublishedWithKeyword,
} from "../commJs/articles";
import { highlightHtml, KEYWORD_TYPES } from "../commJs/keyword";
import previewWatermarkMixin from "../commJs/previewWatermarkMixin";
import { initContentVideoPlayers, processContentVideos } from "../commJs/video";
import { getArticleStatusConfig } from "../constants";

function htmlToPlainText(html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.innerText || "";
}

/**
 * 解析 checkContent 接口返回为关键词分组。
 * @param {unknown} payload 接口返回
 * @returns {{forbid: string[], warn: string[], point: string[], special: string[]}}
 */
function parseKeywordGroups(payload) {
  const root = payload;
  if (!root || typeof root !== "object") {
    return { forbid: [], warn: [], point: [], special: [] };
  }

  let data = root;
  if (
    root.success === "true" ||
    root.success === true ||
    root.data?.point ||
    root.data?.specialPoint ||
    root.data?.special
  ) {
    data = root.data ?? root;
  }
  if (data?.data && (data.success === "true" || data.success === true)) {
    data = data.data;
  }

  return {
    forbid: [],
    warn: [],
    point: Array.isArray(data?.point) ? data.point : [],
    special: Array.isArray(data?.specialPoint)
      ? data.specialPoint
      : Array.isArray(data?.special)
      ? data.special
      : [],
  };
}

export default {
  mixins: [previewWatermarkMixin],
  data() {
    return {
      showRelatedArticles: true,
      loading: true,
      error: false,
      rankData: [],
      relatedNewsData: [],
      errorT: "",
      fontSize: localStorage.getItem("fontSize") || "20",
      id: 0,
      loading2: true,
      newData: [],
      error2: false,
      error2T: "",
      headline: [],
      today: null,
      categoryId: 0,
      title: "",
      bottomPannel: false,
      defaultIndex: 0,
      content: "",
      columns: [
        { text: "小", value: 16 },
        { text: "标准", value: 20 },
        { text: "大", value: 24 },
        { text: "特大", value: 28 },
      ],
      routeTopicTitle: "",
      keywordHighlightEnabled: false,
      highlightedTitleHtml: "",
      highlightedSubTitleHtml: "",
      highlightedContentHtml: "",
      keywordData: {
        forbid: [],
        warn: [],
        point: [],
        special: [],
      },
      keywordTip: {
        show: false,
        left: 0,
        top: 0,
        groups: [],
      },
    };
  },
  computed: {
    // 路由携带的专题 ID：/news/:id/:topicid
    routeTopicId() {
      const topicid = this.$route.params.topicid;
      return topicid != null && String(topicid).trim()
        ? String(topicid).trim()
        : "";
    },
    // 面包屑专题项：由路由参数决定（从专题页进入文章时携带 :topicid）
    breadcrumbTopic() {
      if (!this.routeTopicId) return null;
      return {
        id: this.routeTopicId,
        title: String(this.routeTopicTitle || "").trim(),
      };
    },
    queryKey() {
      const key = this.$route.query.key;
      return typeof key === "string" && key.trim() ? key.trim() : undefined;
    },
    isPreviewMode() {
      return Boolean(this.queryKey);
    },
    isFromWechat() {
      const from = this.$route.query.from;
      return typeof from === "string" && from.trim().toLowerCase() === "wechat";
    },
    shouldHighlightKeywords() {
      return this.isPreviewMode && this.isFromWechat;
    },
    previewStatusConfig() {
      if (!this.isPreviewMode) return undefined;
      return getArticleStatusConfig(this.newData && this.newData.status);
    },
    processedContent() {
      const raw = this.newData.content ? this.newData.content : this.content;
      const html =
        this.keywordHighlightEnabled && this.highlightedContentHtml
          ? this.highlightedContentHtml
          : raw;
      return processContentVideos(html || "");
    },
    showHeat() {
      const news = this.newData || {};
      const baseHeat = Number(news.baseHeat ?? news.base_heat ?? Number.NaN);
      const finalHeat = Number(news.finalHeat ?? news.final_heat ?? Number.NaN);
      if (baseHeat === 0 && finalHeat === 0) return false;

      const currentHeat = news.currentHeat ?? news.current_heat;
      return (
        currentHeat != null && currentHeat !== "" && Number(currentHeat) !== 0
      );
    },
  },
  methods: {
    // 路由携带专题 ID 时，查询专题名称用于面包屑展示
    async loadRouteTopicTitle() {
      const id = this.routeTopicId;
      if (!id) {
        this.routeTopicTitle = "";
        return;
      }
      try {
        const data = await getArticleVoById(id, this.queryKey);
        this.routeTopicTitle = String(data?.title ?? "").trim();
      } catch (error) {
        console.error("加载专题标题失败:", error);
        this.routeTopicTitle = "";
      }
    },
    goTopic(topicId) {
      if (!topicId) return;
      this.$router.push({ name: "topic", params: { id: topicId } });
    },
    initContentVideos() {
      this.$nextTick(() => {
        if (this.cleanupVideoPlayers) {
          this.cleanupVideoPlayers();
          this.cleanupVideoPlayers = null;
        }
        const container = this.$refs.messageContent;
        if (container) {
          this.cleanupVideoPlayers = initContentVideoPlayers(container);
        }
      });
    },
    getDefaultIndex() {
      let index = 0;
      if (this.fontSize === 10) {
        index = 0;
      }
      if (this.fontSize === 20) {
        index = 1;
      }
      if (this.fontSize === 24) {
        index = 2;
      }
      if (this.fontSize === 28) {
        index = 3;
      }
      return index;
    },
    openBottomPannel() {
      this.defaultIndex = this.getDefaultIndex();
      this.bottomPannel = true;
    },
    onChangeFontSizeConfirm(value) {
      this.fontSize = value.value;
      localStorage.setItem("fontSize", value.value);
      this.bottomPannel = false;
    },
    onChangeFontSizeCancel() {
      // this.fontSize = this.previousFontSize;
      // localStorage.setItem("fontSize", this.previousFontSize);
      this.bottomPannel = false;
    },
    goThumb(id) {
      this.$router.push({ name: "news", params: { id: id } });
      if (isWechat) {
        wechatShare();
      } else {
        wechatShare();
      }
    },
    goView(item) {
      const { id, type: t, externalLink } = item;
      if (t === 5) {
        if (externalLink) {
          window.open(externalLink, "_blank", "noopener,noreferrer");
        }
        return;
      }
      if (t === 1) {
        this.$router.push({ name: "news", params: { id: id } });
      } else if (t === 3) {
        this.$router.push({ name: "live", params: { id: id } });
      } else if (t === 2) {
        this.$router.push({ name: "topic", params: { id: id } });
      } else {
        this.$router.push({ name: "news", params: { id: id } });
      }
    },
    getIndex() {},
    view(i) {
      let imgs = [];
      for (let v in this.newData.content) {
        imgs = imgs.concat(this.newData.content[v].img);
      }
      ImagePreview({
        images: imgs,
        startPosition: i,
      });
    },
    // setfontSize(type) {
    //   let fontSize = this.fontSize || localStorage.getItem("fontSize");
    //   if (type === 1) {
    //     this.fontSize = parseInt(fontSize) + 2;
    //   } else {
    //     this.fontSize = parseInt(fontSize) - 2;
    //   }
    //   localStorage.setItem("fontSize", this.fontSize);
    // },
    getFontsize() {
      this.fontSize =
        localStorage.getItem("fontSize") ||
        localStorage.setItem("fontSize", 20);
    },
    clearKeywordHighlight() {
      this.keywordHighlightEnabled = false;
      this.highlightedTitleHtml = "";
      this.highlightedSubTitleHtml = "";
      this.highlightedContentHtml = "";
      this.keywordData = {
        forbid: [],
        warn: [],
        point: [],
        special: [],
      };
      this.keywordTip = { show: false, left: 0, top: 0, groups: [] };
    },
    buildKeywordTipGroups(text, kwTypesAttr) {
      const activeTypes = String(kwTypesAttr || "")
        .split(",")
        .filter(Boolean);
      const groups = [];

      for (let i = 0; i < activeTypes.length; i++) {
        const type = activeTypes[i];
        const config = KEYWORD_TYPES[type];
        const keywords = this.keywordData[type] || [];
        if (!config || !keywords.length) continue;

        const lowerText = text.toLowerCase();
        const matched = keywords.filter((kw) => {
          const lowerKw = String(kw).toLowerCase();
          return lowerKw.includes(lowerText) || lowerText.includes(lowerKw);
        });
        if (!matched.length) continue;

        groups.push({
          type,
          label: config.label,
          keywords: matched,
          bg: config.badgeBg,
          color: config.badgeColor,
        });
      }

      groups.sort(function (a, b) {
        const pb =
          (KEYWORD_TYPES[b.type] && KEYWORD_TYPES[b.type].priority) || 0;
        const pa =
          (KEYWORD_TYPES[a.type] && KEYWORD_TYPES[a.type].priority) || 0;
        return pb - pa;
      });
      return groups;
    },
    /**
     * 从事件目标向上查找高亮节点。
     * @param {EventTarget|null} target
     * @returns {HTMLElement|null}
     */
    findKeywordHighlightEl(target) {
      let el = target;
      while (el && el !== document.body) {
        if (
          el instanceof HTMLElement &&
          el.classList.contains("kw-highlight")
        ) {
          return el;
        }
        el = el.parentNode;
      }
      return null;
    },
    /**
     * 按触摸坐标展示关键词 tip。
     * @param {HTMLElement} highlightEl 高亮节点
     * @param {number} x
     * @param {number} y
     */
    showKeywordTipAt(highlightEl, x, y) {
      if (!this.keywordHighlightEnabled || !highlightEl) return;

      const text = highlightEl.innerText || "";
      const kwTypes = highlightEl.getAttribute("data-kw-types") || "";
      const groups = this.buildKeywordTipGroups(text, kwTypes);
      if (!groups.length) return;

      this.keywordTip = {
        show: true,
        left: x,
        top: y - 30,
        groups,
      };

      this.$nextTick(() => {
        const tipEl = document.getElementById("keyword-tip");
        if (!tipEl) return;
        const { height } = tipEl.getBoundingClientRect();
        let top = y - 30 - height;
        if (top < 8) top = y + 16;
        let left = x;
        const tipWidth = tipEl.offsetWidth || 200;
        if (left + tipWidth > window.innerWidth - 8) {
          left = Math.max(8, window.innerWidth - tipWidth - 8);
        }
        this.keywordTip.left = left;
        this.keywordTip.top = top;
      });
    },
    /**
     * 移动端 touch：点中高亮词显示 tip，点其它区域关闭。
     * @param {TouchEvent} event
     */
    onKeywordTouchStart(event) {
      if (!this.keywordHighlightEnabled) return;
      const touch = event.touches && event.touches[0];
      if (!touch) return;

      const highlightEl = this.findKeywordHighlightEl(event.target);
      if (highlightEl) {
        this.showKeywordTipAt(highlightEl, touch.clientX, touch.clientY);
        return;
      }
      if (this.keywordTip.show) {
        this.keywordTip.show = false;
      }
    },
    /**
     * 预览态且 from=wechat 时，检测标题/副标题/正文关键词并高亮。
     */
    async applyKeywordHighlightIfNeeded() {
      if (!this.shouldHighlightKeywords) {
        this.clearKeywordHighlight();
        return;
      }

      const title = String(this.newData?.title ?? "");
      const subTitle = String(
        this.newData?.subTitle ?? this.newData?.sub_title ?? "",
      ).trim();
      const content = String(this.newData?.content ?? this.content ?? "");
      const checkText = htmlToPlainText(
        title + "\n" + subTitle + "\n" + content,
      );

      try {
        const payload = await checkContent(checkText, "gjms");
        const groups = parseKeywordGroups(payload);
        this.keywordData = groups;
        this.highlightedTitleHtml = highlightHtml(title, groups);
        this.highlightedSubTitleHtml = subTitle
          ? highlightHtml(subTitle, groups)
          : "";
        this.highlightedContentHtml = highlightHtml(content, groups);
        this.keywordHighlightEnabled = true;
      } catch (error) {
        console.error("关键词检测失败:", error);
        this.clearKeywordHighlight();
      }
    },
    applyArticleData(data) {
      this.newData = data;
      this.content =
        this.newData.articlesFrames && this.newData.articlesFrames.length > 0
          ? this.newData.articlesFrames.filter((e) => e.type === 5).content
          : "";
      this.loading = false;
      this.title = data.title;
      document.title = data.title;
      this.today = data.publishedDate?.substr(0, 10) || "";
      this.categoryId = data.categoryId;
      this.showRelatedArticles = true;
      this.getRelatedNewsList();
      wechatShare(data.title);
      this.applyKeywordHighlightIfNeeded().then(() => {
        this.$nextTick(() => {
          this.initContentVideos();
        });
      });
    },
    async getView(id) {
      if (this.queryKey) {
        try {
          const data = await getArticleVoById(id, this.queryKey);
          if (!data || !data.id) {
            this.error = true;
            this.errorT = "该文章不存在";
            this.loading = false;
            return;
          }
          const externalLink = String(
            data.externalLink ?? data.external_link ?? "",
          ).trim();
          if (
            Number(data.type) === 5 &&
            externalLink &&
            /^https?:\/\//i.test(externalLink)
          ) {
            window.location.replace(externalLink);
            return;
          }
          this.applyArticleData(data);
        } catch (error) {
          this.error = true;
          this.errorT = "加载文章失败";
          this.loading = false;
        }
        return;
      }

      const params = { id: id };
      getView(params).then((res) => {
        if (res.success === "true") {
          const externalLink = String(res.data.externalLink || "").trim();
          if (externalLink && /^https?:\/\//i.test(externalLink)) {
            window.location.replace(externalLink);
          } else {
            this.applyArticleData(res.data);
          }
        }
      });
    },
    onClickLeft() {
      this.$router.push({ name: "channe", params: { id: this.categoryId } });
    },
    onClickRight() {
      const route = this.$router.resolve({ name: "smsplan" });
      window.open(route.href, "_blank");
    },
    // getRelatedNewsList(newsId) {
    getRelatedNewsList() {
      let _this = this;
      const relatedType = Number(_this.newData.showRelatedArticles);

      const tonglanPromise = getTonglan({
        categoryId: this.categoryId,
        row: 3,
      })
        .then((res) => {
          if (res.success === "true") {
            _this.headline = Array.isArray(res.data)
              ? res.data.filter((item) => String(item.id) !== String(_this.id))
              : [];
          }
          return _this.headline;
        })
        .catch(() => _this.headline || []);

      const relatedPromise =
        relatedType === 2
          ? queryPublishedWithKeyword(_this.id)
          : relatedType === 1
          ? getRelatedArticles(_this.categoryId, 8, 1, _this.id)
          : getRelatedArticles(1, 8, 1);

      Promise.all([tonglanPromise, relatedPromise])
        .then(([headline, list]) => {
          const headlineIds = new Set(
            (Array.isArray(headline) ? headline : []).map((item) =>
              String(item.id),
            ),
          );
          let filtered = (Array.isArray(list) ? list : []).filter(
            (item) => !headlineIds.has(String(item.id)),
          );
          if (relatedType !== 2) {
            filtered = filtered.slice(0, 5);
          }
          _this.relatedNewsData = filtered;
          _this.loading2 = false;
        })
        .catch(() => {
          _this.loading2 = false;
        });
    },
  },
  watch: {
    processedContent() {
      this.initContentVideos();
    },
    $route: function () {
      this.clearKeywordHighlight();
      this.loadRouteTopicTitle();
      this.loading = true;
      this.newData = "";
      this.id = this.$route.params.id || 0;
      if (!this.id || this.id == 0) {
        this.error = "该文章不存在";
      } else {
        this.getView(this.id);
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("touchstart", this.onKeywordTouchStart);
    if (this.cleanupVideoPlayers) {
      this.cleanupVideoPlayers();
      this.cleanupVideoPlayers = null;
    }
  },
  mounted() {
    this.loadRouteTopicTitle();
    console.log(2);
    this.id = this.$route.params.id || 0;
    if (!this.id || this.id == 0) {
      this.error = "该文章不存在";
    } else {
      this.getView(this.id);
    }
    this.getFontsize();
    window.addEventListener("touchstart", this.onKeywordTouchStart, {
      passive: true,
    });
  },
};
</script>
<style lang="less">
.van-nav-bar {
  padding-left: 14px;
  padding-right: 14px;
}
.van-nav-bar__arrow {
  font-size: 16px !important;
}

.van-nav-bar__text {
  font-size: 13px !important;
  color: #666 !important;
}

.van-nav-bar .van-icon {
  color: #999 !important;
}

.album-pic {
  width: 100%;
}
.scsjb_info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.author {
  width: 70px;
  height: 60px;
  .dlogo {
    width: 60px;
  }
}

.user_info {
  .n {
    color: #666;
    font-size: 16px;
    //font-weight: bold;

    .path {
      color: #999;
    }

    .topic {
      color: #3a60e1;
    }

    .topic-link {
      cursor: pointer;
    }
  }
  .t {
    margin-top: 5px;
    color: #bdbbbb;
    font-size: 13px;
  }
}
.photocentent {
  .imgs {
    background: #eee;
    margin-bottom: 20px;

    .desc {
      color: #666;
      font-size: 14px;
      padding: 0 10px 10px 10px;
    }
  }
}

.message {
  p,
  div {
    margin: 0;
    padding: 10px 30px 10px 30px !important;
    video {
      // margin-left: -30px;
      width: 100% !important;
    }
  }

  p:has(img) {
    // padding: 10px 0px 10px 0px !important;
  }

  p img {
    width: 100% !important;
    padding-top: 10px;
    max-width: 100%;
    height: auto !important;
  }
  p video {
    width: 100% !important;
    max-width: 100%;
    height: auto !important;
  }

  .my-img {
    padding: 10px 0px 10px 0px !important;
    img {
      width: 100%;
      padding-top: 10px;
      max-width: 100%;
      height: auto !important;
    }
  }
}

.copyright {
  text-align: center;
  padding: 15px 0;
  background: #f7f8fa;
  color: #a8abb0;
  font-size: 12px;

  p:first-child {
    display: flex;
    width: 80%;
    margin: 0 auto;
    justify-content: space-around;

    a {
      color: rgba(0, 0, 0, 0.45);
    }
  }

  p:last-child {
    color: rgba(0, 0, 0, 0.25);
  }
}

.van-skeleton {
  padding: 0 !important;

  .van-skeleton__title {
    height: 30px !important;
    width: 70%;
    margin: 5px 0 30px;
  }

  .van-skeleton__row {
    height: 22px !important;
  }
}
</style>
<style scoped lang="less">
.my-swipe {
  // padding: 10px 10px 0 10px;
  // width: calc(100% - 20px);
  width: 100%;
  overflow: hidden;
  padding-top: 10px;
  margin-top: 30px;
}
.my-swipe .thumb {
  position: relative;
  height: 200px;
  // width: calc(100% - 20px);
  overflow: hidden;

  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 80px;
    left: 0;
    bottom: 0;
    background-color: transparent;
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(transparent),
      to(#000)
    );
    background: -webkit-linear-gradient(top, transparent, #000);
    background: -moz-linear-gradient(top, transparent, #000);
    background: -ms-linear-gradient(top, transparent, #000);
    opacity: 0.6;
  }

  .title {
    color: #fff;
    position: absolute;
    bottom: 20px;
    z-index: 1111;
    left: 10px;
    font-size: 18px;
    width: calc(100 - 20px);
  }
}
.newsList {
  // padding: 15px;
  background: #f8f8f8;
  padding: 15px 30px 0 30px !important;

  .lable-title {
    color: #164a9a;
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;

    span {
      position: relative;

      &:after {
        width: 100%;
        position: absolute;
        content: "";
        height: 2px;
        background: #164a9a;
        left: 50%;
        transform: translateX(-50%);
        bottom: -12px;
      }
    }
  }
}

.contents {
  // background: #fff !important;
  background: #f8f8f8 !important;

  // .qrcode {
  //   padding: 0px 30px 0 30px !important;
  //   display: inline;
  // }
  .origin {
    color: #999;
    margin: 0 30px 20px auto;
    text-align: right;
  }
  .promotion {
    margin: 0 auto;
    width: 70%;
    text-align: center;
    font-size: 16px;
  }
  .article-meta-right {
    float: right;
    padding-right: 30px;
    padding-top: 40px;
    text-align: right;
  }
  .article-status {
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 4px;
  }
  .views {
    font-size: 12px;
  }
  .thread-star {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px 10px 30px !important;

    .time {
      font-size: 16px;
      color: #999;

      .user_info .n {
        font-size: 14px;
      }
      .user_info .t {
        font-size: 12px;
      }
    }

    .mode {
      display: flex;
      margin: 10px 0;

      .fontSize {
        &:first-child {
          border-top-left-radius: 30px;
          border-bottom-left-radius: 30px;
          position: relative;

          &:before {
            content: "";
            height: 15px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 0;
            width: 1px;
            background: #efeaeab8;
          }
        }

        &:last-child {
          border-top-right-radius: 30px;
          border-bottom-right-radius: 30px;
        }

        // width: 60px;
        width: 40px;
        height: 30px;
        line-height: 20px;
        text-align: center;
        color: #3763a8;
        background: #f9f8f8;

        .iconfont {
          font-size: 20px;
        }
      }
    }
  }

  .h2subject {
    line-height: 36px;
    font-size: 28px;
    color: #1a1a1a;
    // font-family: PingFangSC-Medium;
    font-weight: bold;
    padding: 15px 30px 0 30px !important;
  }

  .article-subtitle {
    line-height: 28px;
    font-size: 17px;
    color: #666;
    font-weight: normal;
    letter-spacing: 0.5px;
    padding: 10px 30px 0 30px !important;
    white-space: pre-line;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  .message {
    font-size: 20px;
    line-height: 34px;
    text-align: justify;
    padding-top: 0px;
    color: rgb(34, 34, 34);
    p {
      // padding-right: 5px;
      // padding-left: 5px;
      margin: 10px 0;
      &:first-child {
        margin-top: 0;
      }
    }
  }
}

.kw-highlight,
span[data-highlight="yes"] {
  display: inline-block;
  line-height: 2;
  cursor: pointer;
  position: relative;
  border-radius: 2px;
}

.keyword-tip {
  position: fixed;
  z-index: 10000;
  padding: 12px;
  max-width: 280px;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background: #fff;
  color: #606266;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  word-break: break-all;
  pointer-events: none;
}

.keyword-tip-title {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #303133;
}

.keyword-tip-label {
  margin-bottom: 4px;
  font-weight: 600;
}

.keyword-tip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.keyword-tip-tag {
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  height: 24px;
  padding: 0 10px;
  line-height: 24px;
}
</style>
